import logo from "~/assets/app-logo.png"
import { Suspense } from "react"
import { Header } from "~/components/layout/header"
import { UserDisplay, UserDisplaySkeleton } from "./user-display"

export function HomeHeader() {
  return (
    <Header className="justify-between">
      <div className="shrink-0 flex items-center gap-s">
        <img src={logo} alt="Global Women's Service" className="size-header-icon" />
        <div className="leading-tight font-bold">
          <div>GLOBAL</div>
          <div className="text-primary">WOMEN'S</div>
          <div>SERVICE</div>
        </div>
      </div>

      <Suspense fallback={<UserDisplaySkeleton />}>
        <UserDisplay />
      </Suspense>
    </Header>
  )
}
